/* Price buckets expressed as an array of bucket objects, containing:
 * - precision: the amount of decimal places to return
 * - min: the minimum value for the bucket rule
 * - max: the maximum value for the bucket rule
 * - increment: the increments of buckets from min to max
 */

export const buckets = [
  // 0 - 20 at 0.25 increments
  {
    precision: 2,
    min: 0,
    max: 20,
    increment: 0.25,
  },
  // 20 - 40 at 0.5 increments
  {
    precision: 2,
    min: 20,
    max: 40,
    increment: 0.50,
  },
  // 40 - 100 at 1.00 increments
  {
    precision: 2,
    min: 40,
    max: 200,
    increment: 1.00,
  },
];
